<template>
  <div class="history-container" v-loading.fullscreen="loading" element-loading-background="rgba(0, 0, 0, 0.5)" element-loading-text="正在下载...">
    <div class="content-title">动态检测结果</div>
    <div class="content-item">
      <OrganizationTree @nodeClick="nodeClick"></OrganizationTree>
      <div class="content-right">
        <div class="right-title">人员</div>
        <div class="query">
          <MyForm class="search-form" :formOptions="queryForm" :inline="true" label-width="auto"></MyForm>
        </div>
        <MyTable :table-options="tableOptions" border max-height="60vh">
          <template #stress="{ row }">
             <div :style="{color:row.stressColor}">{{row.stress?.toFixed(2)}}</div>
          </template>
          <template #tension="{ row }">
             <div :style="{color:row.tensionColor}">{{row.tension?.toFixed(2)}}</div>
          </template>
          <template #anger="{ row }">
             <div :style="{color:row.angerColor}">{{row.anger?.toFixed(2)}}</div>
          </template>
         <template #suspect="{ row }">
             <div :style="{color:row.suspectColor}">{{row.suspect?.toFixed(2)}}</div>
          </template>
          <template #sleepHealth="{ row }">
             <div :style="{color:row.sleepHealthColor}">{{row.sleepHealth?.toFixed(2)}}</div>
          </template>
          <template #handler="{ row }">
             <div v-if="row.isWarningOrder" style="color: #F56C6C;">
                是
             </div>
             <div v-else>
                否
             </div>
          </template>
          <template #chaozuo="{ row }">
             <el-button
             size="large"
              style="color: #6fcaf7"
              icon="View"
              link
              @click="chakan(row)"
              ></el-button>
          </template>
        </MyTable>
      </div>
    </div>
    <MyPagination :params="paginationParams" :total="total" @get-list="getTesterList" ref="paginationRef" />
                      <el-image-viewer
                        v-if="showPreview"
                        :url-list="srcList"
                        show-progress
                        @close="showPreview = false"
                      />
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import * as XLSX from 'xlsx'
import { useRouter } from "vue-router";
import OrganizationTree from "@/components/Common/OrganizationTree.vue";
import organizationApi from "@/api/organization";
import {getTesterThreeSecondsEvaluation} from "@/api/threeStatistics"
import { dayjs, ElMessage, ElMessageBox ,ElLoading} from "element-plus";
import activityApi from "@/api/activity";
const router = useRouter();

const showPreview=ref(false)
const srcList =ref([])
const chakan=(row)=>{
   const fullBase64 = `data:image/png;base64,${row.faceEvaluationData}`;
  showPreview.value=true
  srcList.value =[fullBase64]
}
// 核心：列宽自适应计算函数（已优化支持隐藏列）
const calcColumnWidths = (excelData, hiddenColumnIndex = -1) => {
  // 全角字符正则（中文/日文/韩文/全角符号，每个占2个英文字符宽度）
  const fullWidthCharReg = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC]/g
  // 列宽配置：最小8，最大50，避免过窄/过宽
  const MIN_WIDTH = 8
  const MAX_WIDTH = 50
  // 内容内边距，避免文字贴边框
  const PADDING = 2

  const columnCount = excelData[0].length
  const widths = []

  // 遍历每一列
  for (let colIndex = 0; colIndex < columnCount; colIndex++) {
    // ✅ 关键：如果是需要隐藏的列，直接设置隐藏配置
    if (colIndex === hiddenColumnIndex) {
      widths.push({ hidden: true }); // 隐藏该列
      continue;
    }

    let maxContentWidth = 0

    // 遍历该列的所有行（表头+数据）
    for (let rowIndex = 0; rowIndex < excelData.length; rowIndex++) {
      const cellValue = excelData[rowIndex][colIndex]
      // 空值跳过
      if (cellValue == null || cellValue === '') continue

      // 转为字符串，计算内容宽度
      const cellStr = String(cellValue)
      // 匹配全角字符数量
      const fullWidthCharCount = (cellStr.match(fullWidthCharReg) || []).length
      // 半角字符数量
      const halfWidthCharCount = cellStr.length - fullWidthCharCount
      // 总宽度：全角*2 + 半角*1
      const currentWidth = fullWidthCharCount * 2 + halfWidthCharCount

      // 更新该列最大宽度
      if (currentWidth > maxContentWidth) {
        maxContentWidth = currentWidth
      }
    }

    // 最终列宽：加上内边距，限制在上下限内
    const finalWidth = Math.min(Math.max(maxContentWidth + PADDING, MIN_WIDTH), MAX_WIDTH)
    widths.push({ wch: finalWidth })
  }

  return widths
}

// 你的导出函数（仅新增列宽适配 + 最后一列默认隐藏）
const handleExportExcel = () => {
  const loading = ElLoading.service({
    fullscreen: true,
    text: '正在生成 Excel，请稍候...',
    background: 'rgba(0, 0, 0, 0.7)',
  })

  try {
    // 第一步：定义Excel表头（和列表列一一对应）
    const excelHeader = [
      ['检测时间', '通道名称', '姓名','年级','班级', '压力程度', '紧张程度', '冲动倾向', '情绪偏离', '睡眠状态', '睡眠结果', '是否预警','文件']
    ]
    // 第二步：把列表数据转成Excel行格式
    const excelRows = tableOptions.tableData.map(item => [
      item.creationTime,
      item.threeSecondsEvaluationChannelName,
      item.testerName,
      item.strValue3,
      item.strValue4,
      item.stress?.toFixed(2),
      item.tension?.toFixed(2),
      item.anger?.toFixed(2),
      item.suspect?.toFixed(2),
      item.sleepHealth,
      item.sleepHealthStatusText,
      item.isWarningOrder == true ? '是' : '否',
      item.evaluationFile
    ])

    // 第三步：合并表头+数据，生成完整Excel数据
    const fullExcelData = [...excelHeader, ...excelRows]

    // 第四步：创建Excel工作簿和工作表
    const worksheet = XLSX.utils.aoa_to_sheet(fullExcelData) // 数组转工作表
    const workbook = XLSX.utils.book_new() // 新建工作簿
    XLSX.utils.book_append_sheet(workbook, worksheet, '动态检测结果') // 追加工作表，命名sheet

    // 👉 核心修改：最后一列索引是 11（从0开始），传入函数自动隐藏
    worksheet['!cols'] = calcColumnWidths(fullExcelData, 12)

    // 第五步：导出文件到PC本地
    XLSX.writeFile(workbook, '动态检测结果.xlsx')
  } catch (error) {
    console.error('Excel导出失败：', error)
    ElMessage.error('导出失败，请稍后重试')
  } finally {
    // 无论成功失败，都关闭loading
    loading.close()
  }
}

const currentUnit = ref({});
const nodeClick = (data) => {
  if (data) {
    console.log("自动获取的组织ID：", data.id);
    currentUnit.value = data;
    paginationParams.OrganizationId = data.id;
    getActivityList(data.id);
  }
}

const activityList = ref([]);
const getActivityList = (id) => {
  if(!id){
    return;
  }
  activityApi.getActivityList({
    SkipCount: 0,
    MaxResultCount: 1000,
    OrganizationId: id
  }).then((res) => {
    activityList.value = res.data.items.map(item=>{
      item.label = item.name;
      item.value = item.id;
      return item;
    })
  })
}

const queryForm = reactive({
  itemList: [
    {
      type: "Date",
      label: "日期筛选:",
      prop: "EvaluationDate",
      attrs: {
        type: "daterange",
        startPlaceholder: "开始时间",
        rangeSeparator: "至",
        endPlaceholder: "结束时间",
        placeholder: "请输入关键词",
        valueFormat: "YYYY-MM-DD",
      },
      events: {
        change: (formData,formRef, val) => {
          if(!val){
            formData.StartDate = undefined;
            formData.EndDate = undefined;
            return;
          }
          formData.StartDate = val[0] + ' 00:00:00';
          formData.EndDate = val[1] + ' 23:59:59';
        },
      },
    },
    {
      type: "Input",
      label: "关键字：",
      prop: "Key",
      attrs: {
        placeholder: "请输入编号/手机号",
        // class: ["w_200"],
      },
    },
    {
      type: "Input",
      label: "姓名：",
      prop: "TesterName",
      attrs: {
        placeholder: "请输入姓名",
        // class: ["w_200"],
      },
    },
    {
      type: "Input",
      label: "组织信息：",
      prop: "StrValue",
      attrs: {
        placeholder: "请输入",
        // class: ["w_200"],
      },
    },
    {
      type: "Select",
      label: "是否预警：",
      prop: "IsWarningOrder",
      options:[
        { label: "是", value: true },
        { label: "否", value: false },
      ],
      attrs: {
        emptyValues: [null, undefined],
        filterable: false,
        placeholder: "请选择",
      }
    },
    // {
    //   type: "Input",
    //   label: "是否预警：",
    //   prop: "TesterName",
    //   attrs: {
    //     placeholder: "请输入姓名",
    //     class: ["w_200"],
    //   },
    // },
    {
        type: "Button",
        value: "查询",
        attrs: {
          icon: "Search",
          style: {
            marginLeft: 0,
          }
        },
        events: {
          click(formData) {
            if(paginationParams.OrganizationId==""){
                  return ElMessage.warning("请先选择组织");
            }
            Object.assign(paginationParams,formData)
            paginationParams.refreshKey++
          },
        },
    },
    {
        type: "Button",
        value: "重置",
        attrs: {
          icon: "Refresh",
        },
        events: {
          click(formData,formRef) {
            formRef.resetFields();
            formData.StartDate = undefined;
            formData.EndDate = undefined;
            Object.assign(paginationParams,formData)
          },
        },
    },
    {
        type: "Button",
        value: "导出",
        attrs: {
          icon: "Upload",
        },
        events: {
          click(formData,formRef) {
            handleExportExcel()
            console.log("导出")
          },
        },
    },
  ],
});

const tableOptions = reactive({
  colList: [
    { label: "序号", type: "index", width: 70 },
    { label: "检测时间", prop: "creationTime", width: 120  },
    { label: "通道名称", prop: "threeSecondsEvaluationChannelName", width: 100   },
    // { label: "编号", prop: "numberId" , width: 80  },
    { label: "姓名", prop: "testerName", width: 100  },
    // { label: "电话", prop: "phone", width: 80  },
    { label: "年级", prop: "strValue3", width: 80  },
    { label: "班级", prop: "strValue4" },
    { label: "压力程度", slot_name: "stress", width: 100   },
    { label: "紧张程度", slot_name: "tension", width: 100   },
    { label: "冲动倾向", slot_name: "anger", width: 100   },
    { label: "情绪偏离", slot_name: "suspect" , width: 100  },
    { label: "睡眠状态", slot_name: "sleepHealth", width: 100  },
    { label: "睡眠结果", prop: "sleepHealthStatusText", width: 120  },
    { label: "是否预警", type: "slot", slot_name: "handler", width: 100  },
    { label: "头像", type: "slot", slot_name: "chaozuo",fixed:"right", width: 110  },
  ],
  tableData: [],
});
// 分页
const paginationParams = reactive({
  OrganizationId: "",
  refreshKey:0,
})
const paginationRef = ref(null);
const total = ref(0);
const getTesterList = (params = paginationRef.value.getList_params) => {
  if(!params.OrganizationId){
    return;
  }
  getTesterThreeSecondsEvaluation(params).then((res) => {
    total.value = res.data.totalCount;
    tableOptions.tableData = res.data.items
  })
}


const loading = ref(false);
const downloadAll = () => {
  // loading.value = true;
  // organizationApi.downloadAllReport(paginationParams).then((res) => {
  //   window.open(res.data);
  // }).finally(()=>{
  //   loading.value = false;
  // })
  if(!currentUnit.value.id){
    return ElMessage.warning("请先选择组织");
  }
  ElMessageBox.prompt('请输入任务名称', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    inputPattern: /\S/,
    inputValue: '报告生成任务',
    inputErrorMessage: '任务名称不能为空',
  }).then(({ value }) => {
    organizationApi.downloadAllReportTask({
      ...paginationParams,
      taskText: value
    }).then((res) => {
      ElMessage.success("任务创建成功，请稍后前往下载中心查看");
    })
  })
}

</script>

<style lang="scss" scoped>
.content-item{
  display: flex;
  min-height: 60vh;
  .content-right {
    flex: 1;
    overflow: hidden;
    .right-title {
      background: #134e92;
      height: 40px;
      line-height: 40px ;
      color: #66baec;
      display: flex;
      justify-content: space-between;
      padding-left: 20px;
    }
    .query {
      background: #03386a;
      padding: 0 20px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #66baec;
      .search-form{
        padding-top: 20px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        :deep(){
          .el-date-editor, .el-input, .el-select{
            // width: 200px;
            width: 300px;
          }
          .w_200{
            width: 150px;
           }
          .el-form-item:has(.download){
            margin-left: auto;
            margin-right: 0;
          }
          .mgr300{
            margin-right: 300px;
          }
        }
      }
    }
  }
}
</style>